import { Typography } from '@hulu/react-style-components';
import { Divider } from 'antd';
import styled from 'styled-components';

import { StyledTable } from '../TableBaseComponents/styled';

export const StyledTitle = styled(Typography).attrs({ variant: 'body2' })`
  color: ${({ theme }): string => theme.admanColors!.blue.solid};
  font-weight: 400;
  max-width: 300px;
  line-break: anywhere;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 46px;
  text-transform: uppercase;

  &:hover {
    cursor: pointer;
  }
`;

export const StyledNotClickableTitle = styled(StyledTitle)<{ $fontSize?: number }>`
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
  font-size: ${({ fontSize }): string => (fontSize ? `${fontSize}px` : '16px')};
  text-transform: none;

  &:hover {
    cursor: auto;
  }
`;

export const StyledVideoRowWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  &:first-child {
    height: 78px;
  }
`;

export const AddGalleryPreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetaInfoWrapper = styled.div`
  display: flex;

  p {
    margin-right: ${({ theme }): string => theme.spacers!.spacer02};

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const StyledDivider = styled(Divider).attrs({ type: 'vertical' })`
  top: 4px;
  background: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  margin-right: ${({ theme }): string => theme.spacers!.spacer04};
`;

export const StyledAdsTable = styled(StyledTable)`
  td {
    padding: ${({ theme }): string => theme.spacers!.spacer04} 0;
  }
`;

export const AdRowVideoWrapper = styled.div`
  max-height: 80px;
  max-width: 180px;
  margin-right: ${({ theme }): string => theme.spacers!.spacer04};
  cursor: pointer;

  img {
    width: 140px;
    height: 78px;
  }

  video {
    width: 140px !important;
    height: 78px !important;
    border-radius: 8px;
  }
`;

export const StyledTableWrapper = styled(StyledTable)`
  border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg1[0]};
  padding: 0 ${({ theme }): string => theme.spacers!.spacer05} ${({ theme }): string => theme.spacers!.spacer05};

  thead {
    position: sticky;
    top: 0;
    margin: 0;
  }
`;

export const StyledTableScrollWrapper = styled.div<{ $tableHeight: string }>`
  max-height: ${({ $tableHeight }): string => $tableHeight};
  overflow: auto;
`;

export const StyledTableHorizontalScrollWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
  border-radius: 16px;

  td {
    min-width: 150px;
    padding-right: ${({ theme }): string => theme.spacers!.spacer08};
  }

  td:first-child {
    width: 500px;
    min-width: 450px;
    padding-right: ${({ theme }): string => theme.spacers!.spacer03};
  }

  td:last-child {
    span {
      width: 42px;
    }
  }

  th {
    padding-right: ${({ theme }): string => theme.spacers!.spacer08};
  }
`;
